import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navItems, siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [drop, setDrop] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setDrop(false);
  }, [location.pathname, location.search]);

  const isLibrary = location.pathname.startsWith("/library");

  const nav = [
    { name: "首页", to: "/" },
    { name: "资料库", to: "/library" },
    ...navItems.map((n) => ({ name: n.name, to: `/library?cat=${n.key}` })),
    { name: "关于", to: "/about" },
  ];

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 shadow-soft backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between md:h-[72px]">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-base font-black text-background-50">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
                51<span className="text-primary-600">瓜网</span>
              </span>
              <span className="text-[11px] font-medium text-foreground-500">{siteInfo.slogan}</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors hover:bg-primary-100 hover:text-primary-800 ${
                  (item.to === "/" && location.pathname === "/") ||
                  (item.to === "/about" && location.pathname === "/about") ||
                  (item.to === "/library" && isLibrary && !item.to.includes("?"))
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <button
              onClick={() => setDrop((v) => !v)}
              className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-800"
            >
              <i className="ri-search-line text-base"></i>
              找热点
              <i className={`ri-arrow-down-s-line text-base transition-transform ${drop ? "rotate-180" : ""}`}></i>
            </button>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-background-200 bg-background-50 text-foreground-800 md:hidden"
            aria-label="菜单"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {drop && (
        <div className="hidden border-t border-background-200 bg-background-50/95 px-4 py-4 backdrop-blur-md md:block">
          <div className="mx-auto max-w-7xl">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-foreground-400">
              按分类查找热点
            </p>
            <div className="flex flex-wrap gap-2">
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/library?cat=${c.id}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-full bg-background-100 px-3.5 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-900"
                >
                  <i className={`${c.icon} text-accent-600`}></i>
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 shadow-soft md:hidden">
          <div className="flex flex-col gap-1">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="flex items-center justify-between rounded-lg px-3 py-2.5 text-[15px] font-medium text-foreground-800 hover:bg-background-100"
              >
                {item.name}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}